import { RoutesEnum } from '@/routes/Routes.enum.ts';

export type HttpCodeModel = Record<string, RoutesEnum | null>;

export const Http400Code: HttpCodeModel = {
  '400_1': null,
  '400_6': null,
} as const;

export const Http401And403Code: HttpCodeModel = {
  '401': RoutesEnum.ROOT,
  '403': RoutesEnum.ROOT,
} as const;

export const Http409Code = {
  '409_1': RoutesEnum.CONFLICT_409,
  '409_2': RoutesEnum.CONFLICT_409,
  '409_3': RoutesEnum.CONFLICT_409,
  '409_closed': RoutesEnum.CONFLICT_409,
} as const;

export const Http500Code: HttpCodeModel = {
  '500': RoutesEnum.ERROR,
} as const;
